/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ParcelLpisIntersect } from './parcelLpisIntersect.model';
import { DnepduosEntity } from './dnepduosEntity.model';


export interface ParcelResponseDto { 
    acquisitionTax?: number;
    acquisitionTaxAdd?: number;
    buyPrice?: number;
    cena?: number;
    cislNazev?: string;
    dnepduos1?: DnepduosEntity;
    dnepduos1Acreage?: number;
    dnepduos1Year?: number;
    dnepduos2?: DnepduosEntity;
    dnepduos2Acreage?: number;
    dnepduos2Year?: number;
    dnepduos3?: DnepduosEntity;
    dnepduos3Acreage?: number;
    dnepduos3Year?: number;
    drupozKod?: number;
    drupozKodMan?: number;
    drupozNazev?: string;
    endDate?: string;
    id?: number;
    isDefunct?: boolean;
    isGeometry?: boolean;
    isLastVersion?: boolean;
    katuzeKod?: number;
    katuzeNazev?: string;
    koeficient?: number;
    krajNazev?: string;
    lv?: number;
    lvString?: string;
    obecNazev?: string;
    okresNazev?: string;
    osvobozenaVymera?: number;
    parId?: number;
    parType?: string;
    parcelLpisIntersect?: ParcelLpisIntersect;
    parcelRentAveragePrice?: number;
    parcelRentFromAcreage?: number;
    parcelRentParcelPrice?: number;
    parcis?: string;
    parcisDil?: number;
    parcisKmen?: number;
    parcisPod?: number;
    priceAddAveragePrice?: number;
    priceAddAveragePricePercent?: number;
    priceAddParcelPrice?: number;
    priceAddParcelPricePercent?: number;
    pronajataVymera?: number;
    prumernaCena?: number;
    realEstateBrokerage?: number;
    startDate?: string;
    tax?: number;
    taxAdd?: number;
    taxComputed?: number;
    taxFromRentedAcreage?: number;
    taxPayerId?: number;
    taxTenant?: boolean;
    type?: number;
    typeValid?: number;
    useTaxFromRentedAcreage?: boolean;
    useTaxReturnDrupozKodOriginal?: boolean;
    vymera?: number;
    zastavenaVymera?: number;
    zpevnenaPlochaX?: number;
    zpevnenaPlochaY?: number;
}

